import React from "react";
import {useEffect, useRef} from "react";
import {AllInclusive as AllInclusiveIcon} from "@mui/icons-material";
import {Grid, Box, Button} from "@mui/material";
import "./Advertiser.css";

import ExpandableImage from "../../components/elements/ExpandableImage";



function bootstrapAnimation() {
    const svg = document.getElementById("home-chart");
    const barCount = 20;
    const maxHeight = 180;
    const barWidth = 600 / barCount;
    const bars = [];

    for (let i = 0; i < barCount; i++) {
        const height = Math.random() * maxHeight;
        const rect = document.createElementNS("http://www.w3.org/2000/svg", "rect");
        rect.setAttribute("x", i * barWidth + 2);
        rect.setAttribute("y", 200 - height);
        rect.setAttribute("width", barWidth - 4);
        rect.setAttribute("height", height);
        rect.setAttribute("fill", "rgba(0, 128, 255, 0.7)");
        svg.appendChild(rect);
        bars.push(rect);
    }

    function animateBars() {
        bars.forEach((bar, index) => {
            const newHeight = 40 + Math.random() * (maxHeight - 40);
            bar.setAttribute("height", newHeight);
            bar.setAttribute("y", 200 - newHeight);
        });
    }

    setInterval(animateBars, 300);
}


export const Testimonial = ({logo, quote, company, signature, link}) => {
    return <div className="testimonial">
        <div className={"testimonial-header"}>
            <a href={link}><img style={{maxHeight: "30px"}} src={logo} alt={company}/></a>
        </div>
        {quote && <blockquote className={"testimonial-quote"}>
            {quote}
        </blockquote>}
        {signature && <span className={"testimonial-signature"}>
            - {signature}
        </span>}
    </div>
}


export const Testimonials = () => {
    return <div className="main-container testimonials">
        <h2>Meet Some of Our Existing Customers</h2>
        <div className="testimonial-list">
            <Testimonial
                logo={`${process.env.REACT_APP_PUBLIC_URI}/home/testimonials/fine-fettle.svg`}
                company={"Fine Fettle"}
                quote={<><p>Understanding our data to look back, project, and manage our business has been incredibly difficult in a new and budding industry without the classic tools operators outside cannabis are used to.</p><p> Canold has been effective working with us to build both what should exist, but also custom reports for understanding what we need to know. Matt and Co. have been responsive and creative to help us gain the insights to reach our goals.</p></>}
                signature={"Benjamin Sachs, CEO, Fine Fettle"}
                link={"https://finefettle.com/"}
            />
            <Testimonial
                logo={`${process.env.REACT_APP_PUBLIC_URI}/home/testimonials/nativesun.webp`}
                company={"Native Sun Cannabis"}
                link={"https://nativesuncannabis.com"}
                quote={<p>Canold and the Canold team have been an integral part of Native Sun&apos;s success since we partnered with them. Having access to not only our data, but to the Canold experts who know the data, has allowed us to streamline and automate the key reporting functions to keep our business running smoothly, without the manual hassle of building reports every month. Their insight into the sales and inventory data has improved our decision making, speed and accuracy across many aspects of our business and allowed us to focus on growing the company instead of collecting and worrying about our data.</p>}
                signature={"Matt Gamble, President & COO, Native Sun Cannabis"}
            />
            <Testimonial
                logo={`${process.env.REACT_APP_PUBLIC_URI}/home/testimonials/redi.png`}
                company={"Redi"}
                link={"https://tryredi.com"}
                quote={<p>Canold is an integral part of our operations, particularly when assessing promotional impacts and conducting quarterly SKU rationalizations</p>}
                signature={"Ryan Silve, Director of Retail, Redi Cannabis"}
            />
            <Testimonial
                logo={`${process.env.REACT_APP_PUBLIC_URI}/home/testimonials/vangarden.webp`}
                company={"Vangarden"}
                link={"https://www.vangardencannabis.com/"}
            />
            <Testimonial
                logo={`${process.env.REACT_APP_PUBLIC_URI}/home/testimonials/coast.jpg`}
                company={"Coast Cannabis"}
                link={"https://coastcannabisco.com/"}
            />
            <Testimonial
                logo={`${process.env.REACT_APP_PUBLIC_URI}/home/testimonials/misty-mountain.svg`}
                company={"Misty Mountain"}
                link={"https://mistymtnshop.com"}
            />
            <Testimonial
                logo={`${process.env.REACT_APP_PUBLIC_URI}/home/testimonials/flower-and-soul.png`}
                company={"Flower & Soul"}
                link={"https://myflowersoul.com/"}
            />
            <Testimonial
                logo={`${process.env.REACT_APP_PUBLIC_URI}/home/testimonials/elysium.png`}
                company={"Elysium Cultivation"}
                link={"https://www.elysiumcultivation.com/"}
            />
            <Testimonial
                logo={`${process.env.REACT_APP_PUBLIC_URI}/home/testimonials/cannabis-connection.webp`}
                company={"Cannabis Connection"}
                link={"https://cannabisconnectiondispensary.com"}
            />
            <Testimonial
                logo={`${process.env.REACT_APP_PUBLIC_URI}/home/testimonials/greenrock.webp`}
                company={"Green Rock Cannabis"}
                link={"https://greenrockcannabis.net"}
            />
        </div>
    </div>
}


export const Advertiser = ({openCreateAccount}) => {

    const svgRef = useRef(null);

    useEffect(() => {
        if (svgRef.current) {
            bootstrapAnimation();
        }
    }, []);

    return (
        <Box className="home">
            <div className="main-header main-container">
                <div className={"header-left"}>
                    <h1 className="headline" style={{textAlign: "center"}}>Canold</h1>
                    <div className={"subheadline"}>
                        <h3>Because enterprise analytics shouldn&apos;t break the bank.</h3>
                        <h2><span className={"promo"}>FREE</span> for the first month, then just <span className={"promo"}>$30</span> per store per month <p className={"tiny"}><a href={"https://www.youtube.com/watch?v=4oDkrzCtm4Q"}>(plus Metrc usage if you choose)</a></p></h2>
                    </div>
                    <svg id="home-chart" ref={svgRef} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 600 200" preserveAspectRatio="none"></svg>
                </div>
                <div className="header-right">
                    <h3 className="responsive-text">
                        If you don&apos;t SAVE, you don&apos;t PAY.
                        <br/>
                        <Button
                            style={{marginTop: "18px", fontSize: "2rem"}}
                            variant={"outlined"}
                            className="secondary"
                            id={"create-account-menu-button-2"}
                            onClick={openCreateAccount}>
                        Get Started
                        </Button>
                    </h3>
                    <ul>
                        <li>Connect your Metrc or Dutchie account</li>
                        <li>Feel confident delegating procurement.</li>
                        <li>Understand ROI with our risk free guarantee.</li>
                        <li>No contract, no commitment</li>
                    </ul>
                </div>
            </div>
            <Testimonials/>
            <h1 className={"main-container-header"}>Canold Manages Over</h1>
            <div className={"main-container inventory-stats"}>
                <div className={"managed"}>
                    <h2>3 BILLION+</h2>
                    <p>Units of Inventory</p>
                </div>
                <div className={"managed"}>
                    <h2>24,000+</h2>
                    <p>Strains</p>
                </div>
                <div className={"managed"}>
                    <h2>8,000+</h2>
                    <p>Vendors and Brands</p>
                </div>
                <div className={"managed"}>
                    <h2>329,000+</h2>
                    <p>Products</p>
                </div>
            </div>

            <h1 className={"divider"}>Features</h1>

            <h1 className={"main-container-header"}>Track Product Trajectory</h1>
            <div className="main-container">
                <div className={"feature-list"}>
                    <img src={`${process.env.REACT_APP_PUBLIC_URI}/home/predict-performance.png`} alt="Predict Product Performance"
                        className={"ad-image"} onClick={openCreateAccount}/>
                    <ExpandableImage src={`${process.env.REACT_APP_PUBLIC_URI}/home/product-detail-a.png`} alt="Track Product Trajectory"/>
                    <ExpandableImage src={`${process.env.REACT_APP_PUBLIC_URI}/home/product-detail.png`} alt="Track Product Trajectory"/>
                    <p>
                        Look at a single product over two time windows to investigate and understand how it&apos;s performance is changing. We use statistical tests to determine if the changes are significant, so you know trends are real.
                    </p>
                </div>
            </div>

            <h1 className={"main-container-header"}>Unlock and Harness the Power of Your Metrc Data with Our Self-Service Tools</h1>
            <div className="main-container feature-list">
                <div className={"feature-list"}>
                    <img src={`${process.env.REACT_APP_PUBLIC_URI}/home/build-reports.png`} alt="Build Reports"
                        className={"ad-image"} onClick={openCreateAccount}/>
                    <ExpandableImage src={`${process.env.REACT_APP_PUBLIC_URI}/home/retail-report.png`} alt="Build Reports"/>
                    <ExpandableImage src={`${process.env.REACT_APP_PUBLIC_URI}/home/report-builder.png`} alt="Build Reports"/>
                    <p>
                        <ul>
                            <li>Automatically connect to Metrc with Canold's API</li>
                            <li>Pull as much data as you want as often as you want</li>
                            <li>Access robust custom reporting tools</li>
                        </ul>
                        {/*Analyze your latest sales by building reports on your freshest data. <br/><br/>*/}
                        {/*You can aggregate, sort, filter, and save reports. Want to share them? You can export to .csv format or make them available throughout your organization.*/}
                        <a href={"https://www.youtube.com/watch?v=kfKvlOrcJTE&feature=youtu.be"} className={"demo-button"}>View Demo 1</a>
                        <a href={"https://youtu.be/AHsNoUbGWVo"} className={"demo-button"}>View Demo 2</a>
                    </p>
                </div>
            </div>

            <h1 className={"main-container-header"}>Maximize Profit and Velocity with Advanced AI</h1>
            <div className="main-container feature-list">
                <div className={"feature-list"}>
                    <img src={`${process.env.REACT_APP_PUBLIC_URI}/home/cutting-edge.png`} alt="Cutting Edge AI"
                        className={"ad-image"} onClick={openCreateAccount}/>
                    <ExpandableImage src={`${process.env.REACT_APP_PUBLIC_URI}/home/inventory-recommendations.png`} alt="Inventory Recommendations"/>
                    <p>Our machine learning models figure out your customer&apos;s preferences, and recommend products that they will like, but that have higher margins for you. You can see the tradeoff between one swap vs. the other, and understand how that will affect your ROI.</p>
                </div>
            </div>

            <h1 className={"main-container-header"}>Robust Product Comparison</h1>
            <div className={"main-container feature-list"}>
                <div className={"feature-list"}>
                    <ExpandableImage src={`${process.env.REACT_APP_PUBLIC_URI}/home/product-comparison.png`} alt="Product Comparison"/>
                    <ExpandableImage src={`${process.env.REACT_APP_PUBLIC_URI}/home/product-comparison2.png`} alt="Product Comparison"/>
                    <p>Compare products across a variety of metrics, including sales, returns, and overall percentile to choose the best products for your customers.</p>
                </div>
            </div>

            <div className="main-container">
                <span>© 2025 Canold, LLC. All rights reserved.</span>
            </div>
        </Box>
    );
};
